import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

interface AreaIconProps extends Omit<SvgIconProps, 'color'> {
  color?: string;
  opacity?: number;
}

const AreaIcon: React.FC<AreaIconProps> = ({
  color = '#9747FF',
  opacity = 0.5,
  ...props
}) => {
  return (
    <SvgIcon {...props} viewBox="0 0 32 32">
      <path
        d="M0.727539 4.36364L10.1821 0L14.5457 2.18182L27.6366 0L26.1821 8L31.273 18.9091L20.3639 20.3636L26.1821 26.1818L17.4548 32L2.90936 20.3636L0.727539 4.36364Z"
        fill={color}
        fillOpacity={opacity}
      />
    </SvgIcon>
  );
};

export default AreaIcon;
